import { COLORS, TYPOGRAPHY } from '@app/constants';
import { BreakpointsEnum } from '@app/types';
import React, { FC } from 'react';
import styled from 'styled-components';
import { EmailForm } from './components';
import loginBackground from '@app/assets/images/login-b2b-bg.svg';
import loginB2BBackgroundResponsive from '@app/assets/images/login-b2b-bg-responsive.svg';
import Container from '@app/components/Container';

interface LoginProps {
  className?: string;
}

const LoginBusiness: FC<LoginProps> = ({ className }) => {
  return (
    <Root>
      <StyledContainer>
        <Form className={className}>
          <Wrapper>
            <LoginTitle>Войти</LoginTitle>
            <div>
              <EmailForm />
            </div>
          </Wrapper>
        </Form>
      </StyledContainer>
    </Root>
  );
};

const Root = styled.section`
  min-height: 600px;
  height: calc(100vh - 58px);

  @media (min-width: ${BreakpointsEnum.sm}px) {
    background: url(${loginBackground.src}) no-repeat center / cover;
  }

  @media (max-width: ${BreakpointsEnum.sm}px) {
    background: url(${loginB2BBackgroundResponsive.src}) no-repeat center /
      cover;
  }
`;

const StyledContainer = styled(Container)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  @media (min-width: ${BreakpointsEnum.sm}px) {
    justify-content: flex-end;
  }

  @media (max-width: ${BreakpointsEnum.sm}px) {
    padding: 0px;
    justify-content: space-around;
  }
`;

const Form = styled.div`
  background-color: ${COLORS.white};
  box-shadow: 0px 12px 80px rgba(86, 118, 159, 0.08);
  border-radius: 16px;
  width: 100%;
  max-width: 440px;
`;

const Wrapper = styled.div`
  @media (min-width: ${BreakpointsEnum.sm}px) {
    padding: 40px 32px 48px 32px;
  }
  @media (max-width: ${BreakpointsEnum.sm}px) {
    padding: 24px 16px 40px 16px;
  }
`;

const LoginTitle = styled.h2`
  ${TYPOGRAPHY.heading3Bold24};
  color: ${COLORS.grayscale700};

  @media (min-width: ${BreakpointsEnum.s}px) {
    margin-bottom: 40px;
  }
  @media (max-width: ${BreakpointsEnum.s}px) {
    margin-bottom: 32px;
  }
`;

export default LoginBusiness;
